import { render, staticRenderFns } from "./qr.vue?vue&type=template&id=2b140c5a&scoped=true&"
import script from "./qr.vue?vue&type=script&lang=js&"
export * from "./qr.vue?vue&type=script&lang=js&"
import style0 from "./qr.vue?vue&type=style&index=0&id=2b140c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b140c5a",
  null
  
)

export default component.exports